"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fetchRemoteComponent = void 0;
var remote_module_loader_1 = __importDefault(require("@paciolan/remote-module-loader"));
var fetchRemoteComponent = function (_a) {
    var requires = _a.requires, url = _a.url, _b = _a.imports, imports = _b === void 0 ? "default" : _b;
    var loadRemoteModule = remote_module_loader_1["default"]({ requires: requires });
    return loadRemoteModule(url).then(function (module) {
        var Component = module && module[imports];
        if (!Component) {
            throw new Error("Could not load '" + imports + "' from '" + url + "'.");
        }
        return Component;
    });
    // suppressHydrationWarning={true}
};
exports.fetchRemoteComponent = fetchRemoteComponent;
//# sourceMappingURL=fetchRemoteComponent.js.map